export const option = [

    {
        label: "How was the overall quality of the food provided at the anganbadi center today?",
        alias:"Today's Food Quality",
        options: []
    },
    {
        label: "Did the food meet the required nutritional standards? If not, please provide details.",
        alias:"Nutritional Standards",
        options: []
    },
    {
        label: "Was the food hygienically prepared and served?",
        alias:"Food Hygiene ",
        options: []
    },
    {
        label: "Were there any issues with the taste, texture, or appearance of the food? ",
        alias:"Texture/Taste of Food",
        options: []
    },
    {
        label: "Were there any issues with the quantity of food provided?",
        alias:"Food Quantity",
        options: []
    },
    {
        label: "Were there any issues with the storage or handling of the food?",
        alias:"Food Storage & Handling",
        options: []
    },
    {
        label: "Were there any issues with the utensils or equipment used to prepare or serve the food?",
        alias:"Food Utensils or Equipment",
        options: []
    },
    {
        label: "Were there any issues with the cleanliness of the eating area or kitchen?",
        alias:"Cleanliness of Kitchen",
        options: []
    },
    {
        label: "Did you observe any waste or spoilage of food?",
        alias:"Food Wastage or Spoilage",
        options: []
    },
    {
        label: "Do you have any suggestions for improving the quality of the food at the anganbadi center?",
        alias:"Suggestions",
        options: []
    },
]









